<template lang="html">

  <section class="profile" v-if="showUser">
    <v-content>
      <v-row>
        <v-col cols="12">
          <v-btn class="float-right" v-if="$vuetify.breakpoint.smAndDown" @click="$emit('logout')">Sign Out</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="1" md="1" sm="2" cols="3">
          <v-avatar size="100" v-if="showUser.picture_path" class="avatar">
            <img :src="img_url + showUser.picture_path" alt="Profilbild"/>
          </v-avatar>
          <v-avatar size="100" v-else class="avatar">
            <v-icon class="avatar_default">mdi-account</v-icon>
          </v-avatar>
        </v-col>
        <v-col lg="7" md="7" sm="6" cols="8" :class="{user_info: $vuetify.breakpoint.mdAndUp}">
          <h1 class="pl-5">{{ showUser.name }}</h1>
          <v-btn v-if="!this.$route.params.id" x-small class="ml-5" @click.stop="editDialog = true" color="accent">
            Edit Profile
          </v-btn>
          <v-btn v-else-if="!this.showUser.isFriend" x-small class="ml-5" @click="addFriend" color="accent">
            Add Friend
          </v-btn>
          <v-btn v-else x-small class="ml-5" @click="removeFriend" color="accent">
            Remove Friend
          </v-btn>
        </v-col>
        <v-col lg="3" md="3" sm="3" cols="12" justify="center" align="center" align-self="center"
               class="user_list_info">
          <v-row align="center" justify="center">
            <v-col cols="6" class="ml-0 pl-0 mr-0 pr-0">
              <router-link :to="{ name: 'users', params: { users: friends } }">
                <p class="user_list_info_item"><span>{{ friends.length }}</span><span>Friends</span></p>
              </router-link>
            </v-col>
            <v-col cols="6" class="ml-0 pl-0 mr-0 pr-0">
              <router-link :to="{ name: 'allGames', params: { type: 'you', id: 'list'} }"><a>
                <p class="user_list_info_item"
                   v-if="headlines[0]">
                  <span>{{ headlines[0].games.data.length }}</span><span>Games</span>
                </p>
              </a></router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-dialog v-model="editDialog">
        <v-card color="accent">
          <v-card-title class="headline">Edit Profile</v-card-title>
          <v-card-text>
            <v-text-field v-model="editUsername" outlined label="Benutzername"></v-text-field>
            <input type="file" ref="profilePic" style="display: none" @input="setProfilepic"/>
            <v-avatar size="100" v-if="showUser.picture_path || profilePicUrl !== ''" class="avatar edit_avatar"
                      @click="$refs.profilePic.click()">
              <img :src="profilePicUrl" alt="Profilbild"/>
            </v-avatar>
            <v-avatar size="100" v-else class="avatar avatar_default edit_avatar"
                      @click="$refs.profilePic.click()">
              <v-icon class="default_avatar">mdi-account</v-icon>
            </v-avatar>
            <br>
            <v-btn class="mt-5" @click="editProfile">Edit</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <GameList v-if="$route.params.id" :headlines="headlines" :voteable="false" :show-rating="true" type="user"
                :url="''"></GameList>
      <GameList v-else :headlines="headlines" :voteable="false" :show-rating="true" type="you" :url="''"></GameList>
      <GameList v-if="$route.params.id" :headlines="wishlist" :voteable="false" :show-rating="false" type="wishlist"
                :url="''"></GameList>
      <GameList v-else :headlines="wishlist" :voteable="false" :show-rating="false" type="yourWishlist"
                :url="''"></GameList>
    </v-content>
  </section>

</template>

<script lang="js">
import Vue from 'vue'
import VueRouter from 'vue-router'
import UserService from "../../services/UserService";
import GameList from "../games/GameList";
import GameListService from "../../services/GameListService";

Vue.use(VueRouter);
export default {
  name:       'profile',
  components: {GameList},
  props:      ['user'],
  mounted () {
    this.getRatings();
    this.getWishlist();
    this.getFriends();
  },
  created () {
    if (this.$route.params.id) {
      this.getUser(this.$route.params.id);
    }
  },
  data () {
    return {
      'id':             0,
      'headlines':      [],
      'wishlist':       [],
      'friends':        [],
      'followers':      [],
      'editDialog':     false,
      'editUsername':   "",
      'editProfilepic': null,
      'img_url':        window.api_url + "/storage/image/user/",
      'profilePicUrl':  '',
      'showUser':       null,
    }
  },
  watch:      {
    user:   {
      immediate: true,
      handler () {
        if (!this.$route.params.id) {
          this.loggedIn();
          if (this.user) {

            this.showUser     = this.user;
            this.editUsername = this.user.name;
            if (this.user.picture_path) {
              this.profilePicUrl = window.api_url + "/storage/image/user/" + this.user.picture_path;
            }
          }
        }
      }
    },
    $route: {
      handler () {
        if (this.$route.params.id) {
          this.getUser();
          this.getFriends();
        } else {
          this.getFriends();
          this.showUser = this.user;
        }
        this.getRatings();
      }
    }
  },
  methods:    {
    setProfilepic () {
      this.editProfilepic = this.$refs.profilePic.files[0];
      this.profilePicUrl = URL.createObjectURL(this.editProfilepic);

      //const width  = 200;
      //const height = 200;
      //const img    = new Image();
      //const file = this.$refs.profilePic.files[0];
      //const fileName = file.name;
      //const reader = new FileReader();
      ////this.profilePicUrl  = URL.createObjectURL(this.editProfilepic);
      //
      //reader.addEventListener("load", () => {
      //  this.profilePicUrl = reader.result;
      //  img.src            = reader.result;
      //
      //  const elem  = document.createElement('canvas');
      //  elem.width  = width;
      //  elem.height = height;
      //  const ctx   = elem.getContext('2d');
      //  ctx.drawImage(img, 0, 0, width, height);
      //  //const data = ctx.canvas.toDataURL(this.editProfilepic.type, 0.7);
      //  //console.log(data);
      //
      //  ctx.canvas.toBlob((blob) => {
      //    const tempFile          = new File([blob], 'profilePic.jpg', {
      //      type:         file.type,
      //      lastModified: Date.now()
      //    });
      //    this.profilePicUrl  = URL.createObjectURL(tempFile);
      //    this.editProfilepic = tempFile;
      //    console.log(tempFile);
      //    console.log(this.profilePicUrl);
      //  }, file.type, 0.7);
      //});


    },
    loggedIn () {
      let user = JSON.parse(localStorage.getItem('user'));
      if (!user || !user.access_token) {
        this.$router.push('/login');
      }
    },
    addFriend () {
      UserService.addFriend(this.showUser.email)
                 .then(() => {
                   this.showUser.isFriend = true;
                 })
                 .catch(err => console.log(err));
    },
    removeFriend () {
      UserService.removeFriend(this.showUser.email)
                 .then(() => {
                   this.showUser.isFriend = false;
                 })
                 .catch(err => console.log(err));
    },
    getRatings () {
      this.headlines = [];
      if (!this.$route.params.id) {
        UserService.getRatings(10)
                   .then(res => {

                     const list = {
                       games: {
                         data: [],
                       },
                       name:  "Ratings"
                     };
                     res.data.games.data.forEach(rating => {
                       rating.game.user_rating = parseFloat(rating.stars);
                       list.games.data.push(rating.game);

                     });
                     list.loaded           = true;
                     this.headlines.loaded = true;
                     this.headlines.push(list);
                   })
                   .catch(err => console.log(err));
      } else {
        UserService.getRatingsById(this.$route.params.id, 10)
                   .then(res => {

                     const list = {
                       games: {
                         data: [],
                       },
                       name:  "Ratings",
                       id:    this.$route.params.id
                     };
                     res.data.games.data.forEach(rating => {
                       rating.game.user_rating = parseFloat(rating.stars);
                       list.games.data.push(rating.game);
                     });
                     list.loaded           = true;
                     this.headlines.loaded = true;
                     this.headlines.push(list);
                   })
                   .catch(err => console.log(err));
      }
    },
    getFriends () {
      if (!this.$route.params.id) {
        UserService.getFriends()
                   .then(res => {
                     this.friends = res.data;
                   })
                   .catch(err => console.log(err));
      } else {
        UserService.getFriendsFromUser(this.$route.params.id)
                   .then(res => {
                     this.friends = res.data;
                   })
                   .catch(err => console.log(err));
      }
    },
    getUser (id) {
      UserService.getUserById(id)
                 .then(res => {
                   this.showUser = res.data;
                   console.log(this.showUser);
                 })
                 .catch(err => console.log(err));
    },
    editProfile () {

      let formData = new FormData();
      formData.append('name', this.editUsername);
      formData.append('profilePic', this.editProfilepic);
      formData.append('_method', 'PUT');

      UserService.edit(formData)
                 .then(res => {
                   this.user.picture_path = res.data.picture_path;
                   this.user.name         = res.data.name;
                   this.editDialog        = false;
                   this.$forceUpdate();
                   console.log(this.user);
                 })
                 .catch(err => console.log(err));
    },
    getWishlist () {
      if (!this.$route.params.id) {
        GameListService.getWishlist(10)
                       .then((res) => {
                         const list           = {
                           games: {
                             data: res.data.games.data,
                           },
                           name:  res.data.wishlist.name
                         };
                         list.loaded          = true;
                         this.wishlist.loaded = true;
                         this.wishlist.push(list);
                       })
                       .catch(err => console.log(err));
      } else {
        GameListService.getWishlistById(10, this.$route.params.id)
                       .then((res) => {
                         console.log(res);
                         const list           = {
                           games: {
                             data: res.data.games.data,
                           },
                           name:  res.data.wishlist.name,
                           id:    this.$route.params.id
                         };
                         list.loaded          = true;
                         this.wishlist.loaded = true;
                         this.wishlist.push(list);
                       })
                       .catch(err => console.log(err));
      }
    }
  },
  computed:   {}
}


</script>

<style scoped lang="scss">
.profile {

}


.user_info {
  margin: 5px 0 0 30px;
}

.user_list_info {
  display: flex;

}

.user_list_info_item {
  padding: 10px 15px 10px 15px;
  border-left: 1px solid var(--v-border-base);
  color: var(--v-secondary-base);
  font-size: 1em;
}

.user_list_info_item span {
  display: block;
}

#profilepic_edit_icon {
  position: absolute;
  bottom: 0;
  right: 0;
}

.edit_avatar {
  cursor: pointer;
}

.edit_avatar:hover {
  background-color: #8080809e;
}
</style>
